import React from "react";
import "./Hero.css";
import Heart from "../../assets/heart.png";
import Heroimg from "../../assets/heroimg.png";
import Hero_img_back from "../../assets/hero_image_back.png";
import Calories from "../../assets/calories.png";
import Header from "../Header/Header";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";

const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  return (
    <div className="Hero" id="hero">
      <div className="blur blur-H"></div>
      <div className="l-Side">
        <Header />
        <div className="ad">
          <motion.div
            initial={{ left: mobile ? "178px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>The Best Fitness Club in the town</span>
        </div>
        <div className="heading-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>YOUr</span>
          </div>
          <div>
            <span>Ideal Body</span>
          </div>
          <div>
            <span>
              In here we will help you to shape and build your ideal body and
              live up your life to fullest
            </span>
          </div>
        </div>
        <div className="figures">
          <div>
            <span>
              <NumberCounter
                end={140}
                start={100}
                delay="4"
                preFix="+"
              ></NumberCounter>
            </span>
            <span>Expert coaches</span>
          </div>
          <div>
            <span>
              <NumberCounter
                end={850}
                start={810}
                delay="4"
                preFix="+"
              ></NumberCounter>
            </span>
            <span>member joined</span>
          </div>
          <div>
            <span>
              <NumberCounter
                end={50}
                start={10}
                delay="4"
                preFix="+"
              ></NumberCounter>
            </span>
            <span>Fitness program</span>
          </div>
        </div>
        <div className="hero-btn">
          <button className="btn">Get Started</button>
          <button className="btn">Learn More</button>
        </div>
      </div>
      <div className="r-Side">
        <button className="btn btn-primary">Join Now</button>
        <motion.div
          className="heart"
          transition={transition}
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
        >
          <img src={Heart} alt="Heart" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>
        <img src={Heroimg} alt="hero" className="hero-img" />
        <motion.img
          src={Hero_img_back}
          alt="hero-back"
          className="hero-img-back"
          initial={{ right: "11rem" }}
          whileInView={{ right: "20rem" }}
          transition={transition}
        />
        <motion.div
          className="calories"
          transition={transition}
          initial={{ right: "37rem" }}
          whileInView={{ right: "28rem" }}
        >
          <img src={Calories} alt="calories" />
          <div>
            <span>Calories burned</span>
            <span>220 Kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
